
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/watercraft",
      function () {
        return require("private-next-pages/products/watercraft/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/watercraft"])
      });
    }
  